import { render } from "./DescText.vue?vue&type=template&id=48e5b0c7"
import script from "./DescText.vue?vue&type=script&lang=js"
export * from "./DescText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__